import React, {useState, useEffect} from 'react';
import './About.scss';
import {motion} from 'framer-motion'; 
import { AppWrap, MotionWrap } from '../../wrapper';  //importing hoc this will also force component to take full space of screen
// import {images} from '../../constants';

import { urlFor, client } from '../../client';  //importing backend connection files

// const abouts= [  //creating array of objects for static abouts
//   {title:"Competitive Programmer", description:"Improving Programmer, who is upgrading his logical and analytical skills on regular basis by trying to solve as many Industry level problems as possible with the most optimized solutions", imgUrl: images.about02},
//   {title:"Frontend Developer", description:"I am a Frontend Developer with a passion for building beautiful & functional web applications.", imgUrl: images.about04},
//   {title:"Backend Developer", description:"I am a Beginner in Backend Development who is regularly learning & improving, with a passion to make Web Applications functional", imgUrl: images.about01}
// ]

const About = () => {
  const [abouts, setAbouts]= useState([]);  //creating a empty state for dynamic abouts data from backend

  useEffect(()=>{  //requesting data from backend
    const query= '*[_type == "abouts"]';  //for fetching about section from backend
    client.fetch(query).then((data)=>{ setAbouts(data); })  //will return a promise
  },[]); //passing empty array as only want to run it once at the start component get mount type

  return (
    <div className='app__about'>
      <h2 className="head-text">
        I Know That Every <span>Skill We Acquire</span><br />Doubles Our <span>Odds Of Success</span>
      </h2>
      <div className="app__profiles">
        {abouts.map((about, index)=>(  //for each about will be returning a motion div
            <motion.div
              whileInView={{opacity: 1}}
              whileHover={{scale:1.1}}
              transition={{duration: 0.5, type:'tween'}}
              className='app__profile-item'
              key={about.title + index}>
                  <img src={urlFor(about.imgUrl)} alt={about.title} />  {/*if not using dynamic data then directly use about.imgUrl */}
                  <h2 className="bold-text" style={{marginTop:20}}>{about.title}</h2>
                  <p className="p-text" style={{marginTop:10}}>{about.description}</p>
            </motion.div>
        ))}
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'), 
  'about',
  'app__whitebg'
  );  //using HOC and setting about as about, first wrapping in Addwrap and then wrapping the main comp in motionwrap
